import { ReactNode } from 'react'
import { Header1, WaveLoader } from '@/ui/components/'
import { useAuth } from '@/modules/auth'
import { AppShell } from '@/ui/layout/AppShell'

interface PageLayoutProps {
  children: ReactNode
  showHeader?: boolean
  className?: string
}

export default function PageLayout({ children, showHeader = true, className = '' }: PageLayoutProps) {
  const { isAuthenticated, isLoading } = useAuth()

  // Show loading state while auth is initializing
  if (isLoading) {
    return (
      <div className={`min-h-screen bg-earth-50 ${className}`}>
        <main className="flex items-center justify-center">
          <WaveLoader />
        </main>
      </div>
    )
  }

  // Authenticated app: use AppShell (right sidebar, no top header)
  if (showHeader && isAuthenticated) {
    return (
      <AppShell className={className}>
        {children}
      </AppShell>
    )
  }

  // Unauthenticated or no header: optional top header, no sidebar
  return (
    <div className={`min-h-screen bg-earth-50 ${className}`}>
      {showHeader && <Header1 />}
      <main className={showHeader ? 'pt-20' : ''}>
        {children}
      </main>
    </div>
  )
}
